import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=049e6ae9&"
import script from "./EditProject.vue?vue&type=script&lang=js&"
export * from "./EditProject.vue?vue&type=script&lang=js&"
import style0 from "./EditProject.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditProject.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports